<template>
  <div v-if="emailFilledAutomatically">
    <Alert type="info">
      <template #title>{{ t("title") }}</template>
      <span class="block mt-1 text-xs">{{ t("description") }}</span>
    </Alert>
  </div>
</template>

<script>
import { Alert } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  name: "EmailAutoAlert",

  components: { Alert },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    emailFilledAutomatically: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<i18n src="./EmailAutoAlert.i18n.json"></i18n>
